import { makeStyles } from '@material-ui/core/styles';

const carouselOneStyle = makeStyles({
  bannerContainer: {
    clear: 'both',
    width: '100%',
    maxHeight: '320px',
    margin: '16px auto 8px',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default carouselOneStyle;
